const API = process.env.REACT_APP_BACKEND_URL;

export const ci = async (path, token, body = {}) => {
  const r = await fetch(`${API}/api/corporate-invoices/${path}`, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token, ...body }),
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.detail || "Request failed");
  return d;
};

export const ciPdf = async (token, inv) => {
  const r = await fetch(`${API}/api/corporate-invoices/pdf`, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token, id: inv.id }),
  });
  if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || "Download failed");
  const a = document.createElement("a");
  a.href = URL.createObjectURL(await r.blob());
  a.download = `${inv.invoice_number.replace(/\//g, "-")}.pdf`;
  a.click();
};

let CFG = {};
export const setCountryConfigs = (c) => { CFG = c || {}; };
const FALLBACK = {
  India: { country: "India", currency_symbol: "₹", tax_type: "GST_INDIA", tax_rate: 5, tax_label: "GST", tax_reg_key: "gstin", tax_reg_label: "GSTIN", customer_tax_label: "GSTIN", entity_fields: [], bank_fields: [], payment_modes: ["NEFT", "RTGS", "IMPS", "UPI", "CHEQUE"] },
  Australia: { country: "Australia", currency_symbol: "A$", tax_type: "FLAT", tax_rate: 10, tax_label: "GST", tax_reg_key: "abn", tax_reg_label: "ABN", customer_tax_label: "ABN", line_tax_exempt: true, entity_fields: [], bank_fields: [], payment_modes: ["EFT"] },
};
export const cfgOf = (country) => CFG[country || "India"] || FALLBACK[country || "India"] || { ...FALLBACK.India, country, currency_symbol: "", tax_type: "NONE", tax_rate: 0 };

export const fmt = (v, country) => {
  if (v === null || v === undefined) return "—";
  const c = cfgOf(country);
  return `${Number(v) < 0 ? "-" : ""}${c.currency_symbol}${Math.abs(Number(v)).toLocaleString(c.country === "India" ? "en-IN" : "en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const STATUS_STYLE = {
  DRAFT: "bg-slate-100 text-slate-700", RETURNED: "bg-orange-100 text-orange-800", PENDING_APPROVAL: "bg-amber-100 text-amber-800",
  APPROVED: "bg-emerald-100 text-emerald-800", REJECTED: "bg-red-100 text-red-800",
};

// Mirrors backend compute() for the live preview; the server recalculates on save.
export const calc = (f, country) => {
  const c = cfgOf(country);
  const items = f.items.map((i) => ({ ...i, amount: (Number(i.qty) || 0) * (Number(i.rate) || 0), tax_free: !!(c.line_tax_exempt && i.tax_free) }));
  const original = items.reduce((s, i) => s + i.amount, 0);
  const final = Number(f.final_agreed_amount) || original;
  const rate = c.tax_type === "NONE" ? 0 : Number(c.tax_rate);
  const inc = f.amount_basis === "INCLUSIVE";
  const share = original ? items.filter((i) => !i.tax_free).reduce((s, i) => s + i.amount, 0) / original : 1;
  const fTax = final * share, fFree = final - fTax;
  const taxable = inc ? fTax / (1 + rate / 100) : fTax;
  const gst = inc ? fTax - taxable : taxable * rate / 100;
  return { original, discount: original - final, pct: original ? ((original - final) / original) * 100 : 0, final, taxable, free: fFree, net: taxable + fFree, gst, total: taxable + gst + fFree, rate, label: c.tax_label };
};
